export const MAX_FILE_SIZE = 20; // 'MB'
export const FILE_TYPE_IMAGE = 'image';
export const NOT_ALLOWED_IMAGE_TYPE = ['tiff', 'gif'];
